import Vue from 'vue'

const DESIGN = 1920   // 与 rem.js DESIGN_WIDTH 一致

function debounce(fn, delay) {
  let timer = null
  return function(...args) {
    clearTimeout(timer)
    timer = setTimeout(() => fn.apply(this, args), delay)
  }
}

/**
 * 全局唯一的响应式视口宽度。
 * 用 Vue.observable 而不是每个组件各自的 data()，
 * 这样只需要一个 window resize 监听器，而不是每个组件实例各挂一个。
 */
const viewportState = Vue.observable({ width: document.documentElement.clientWidth })

const handleResize = debounce(() => {
  viewportState.width = document.documentElement.clientWidth
}, 200)
window.addEventListener('resize', handleResize)

/**
 * 挂到 Vue.prototype 上，任意组件内 this.px2rem(px) 直接可用，
 * 且读取的是响应式的 viewportState.width，模板里用到 px2rem() 的地方
 * 在窗口尺寸变化时依然会正常重新渲染。
 * 不再通过 Vue.mixin 全局注册——避免给应用里每一个组件实例
 * （按钮、输入框等大量与此无关的组件）都挂一份 resize 监听和响应式数据，
 * 这在页面切换、组件树批量创建/销毁时会有明显的额外开销。
 */
Vue.prototype.px2rem = function(px) {
  const ratio = viewportState.width / DESIGN
  return Math.round(px * ratio)
}

/**
 * 仅供需要在窗口尺寸变化时强制重建 el-table（修复部分场景下列宽不自适应）的页面使用，
 * 按需 `mixins: [px2remMixin]` 显式引入。
 */
export const px2remMixin = {
  data() {
    return {
      tableKey: 0
    }
  },
  created() {
    this._unwatchViewport = this.$watch(
      () => viewportState.width,
      () => { this.tableKey++ }
    )
  },
  beforeDestroy() {
    if (this._unwatchViewport) this._unwatchViewport()
  }
}
